import {styled} from "@mui/material/styles";
import Typography from "@mui/material/Typography";

const Header = styled(Typography)({
    fontWeight: 700,
    marginTop: '1.2rem',
    marginBottom: '0.5rem',
    fontSize: '3rem',
    fontFamily: 'inherit',
    border: '2px solid transparent'
})

export default Header
